import React, { useEffect, useState } from 'react';
import { Header, Footer, LeftMenu } from '../commons/components';
import { Content } from './components';
import { usePageSettingHeaderStore } from '../commons/stores';
import { Link, Redirect } from 'react-router-dom';
import { ListHeader, ListPaging, CardList } from './components';
import { useDispatch } from 'react-redux';
import { getAllCustomer } from '../redux/actions/actCustomer';
import { useSelector } from 'react-redux';
import { isAuth } from '../auth/actions';

export default function Home({ employees }) {
  const [statePageSettingHeader] = usePageSettingHeaderStore();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
  const dispatch = useDispatch();
  const themes = useSelector((state) => state.redTheme);
  const [inputSearch, setInputSearch] = useState('');
  const [sortBy, setSortBy] = useState('');
  // const [dataTheme, setDataTheme] = useState([])

  useEffect(() => {
    console.log('get data post:', employees);
    dispatch(getAllCustomer());
  }, []);

  let contentUi = <div className='loader-block' />;
  if (themes) {
    contentUi = (
      <React.Fragment>
        {/* <ListTable data={state.data} /> */}
        {/* <CardList /> */}
        <CardList
          employees={employees}
          search={inputSearch}
          sortData={sortBy}
        />
        <ListPaging employees={employees} />
      </React.Fragment>
    );
  }

  const handleSearch = (event) => {
    setInputSearch(event.target.value);
  };
  const handleSortBy = (event) => {
    setSortBy(event.target.value);
  };

  return (
    <div className='App'>
      <Header />
      {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}

      {isAuth() ? (
        <main className='workspace'>
          <section className='breadcrumb lg:flex items-start'>
            <div>
              <h1>List of Employees</h1>
              <ul>
                <li>
                  <Link to='/employees-management'>Home</Link>
                </li>
                <li className='divider la la-arrow-right'></li>
                <li>List of Employees</li>
              </ul>
            </div>
            <div className='lg:flex items-center ml-auto mt-5 lg:mt-0'>
              <form
                onSubmit={handleSearch}
                className='flex items-center lg:ml-2 mt-5 lg:mt-0'
                action='#'
              >
                <label className='form-control-addon-within rounded-full border-secondary'>
                  <input
                    type='text'
                    className='form-control border-none'
                    placeholder='Please input theme name'
                    // onChange={(event) => setSearch(event.target.value)}
                    value={inputSearch}
                    onChange={handleSearch}
                  />
                  <button
                    type='submit'
                    className='btn btn-link text-secondary dark:text-gray-700 hover:text-primary dark:hover:text-primary text-xl leading-none la la-search mr-4'
                  ></button>
                </label>
              </form>

              <div className='flex mt-5 lg:mt-0'>
                <div className='dropdown lg:ml-2'>
                  <select
                    id='sortby'
                    name='sortby'
                    onChange={handleSortBy}
                    className='mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-full'
                  >
                    <option defaultChecked value='0' disabled>
                      Sort by
                    </option>
                    <option value=''>All Employees</option>
                    <option value='1'>Publish</option>
                    <option value='0'>Unpublish</option>
                  </select>
                </div>

                {/* <Link
                  to={`/employee-management/add`}
                  className='btn btn_primary uppercase ml-2'
                >
                  Add a new Theme
                </Link> */}
              </div>
            </div>
          </section>

          {contentUi}

          <Footer />
        </main>
      ) : (
        <Redirect to='/auth' />
      )}
    </div>
  );
}
